module.exports = __webpack_public_path__ + "images/videoCaseStudy-urbanPartnershipBank-whyus-photo-01.jpg?h=7d71e986b7fddd2e90a99af65076d56b";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/urbanPartnershipBank/videoCaseStudy-urbanPartnershipBank-whyus-photo-01.jpg
// module id = 2129
// module chunks = 12 15